





























import { computed, defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { Review } from "@scrile/api-provider/dist/api/ReviewProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { timeAgo } from "@/lib/time";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIcon from "@/components/BaseIcon";
import LinkifiedText from "@/components/LinkifiedText";

export default defineComponent({
  name: "ReviewsItem",
  components: { BaseIcon, BaseAvatar, LinkifiedText },
  props: {
    review: { type: Object as () => Review, required: true },
    canRemove: { type: Boolean, default: false },
    allowReply: { type: Boolean, default: true },
  },
  setup: function(props) {
    const profileUrl = computed<Location>(() => getProfileUrl(props.review.reviewerUser));
    const { authUser } = useAuthUser();

    const isReviewOwner = computed(() => {
      return props.review.reviewerUser.id === authUser.value?.id;
    });
    const time = computed(() => {
      return timeAgo(props.review.time);
    });

    const isAllowExternalLinks = computed(() => {
      return !!(props.review.reviewerUser as UserPublicData)?.verified;
    });

    return {
      isAllowExternalLinks,
      isReviewOwner,
      profileUrl,
      time,
    };
  },
});
